import * as React from 'react';
import * as Moment from "moment";
import { StatWidget } from './StatWidget';
import { StudyProgressModel } from '../progress-widget-app';
import { DateTimeAccuracy, LocalizedDateTime } from '../../misc/components/LocalizedDateTime';

interface OverviewProps {
    OverallProgress: StudyProgressModel;
}

export class Overview extends React.Component<OverviewProps, any> {
    constructor(props: OverviewProps) {
        super(props)
    }

    renderIncorrectConfiguration = () => {
        if (this.props.OverallProgress.ExpectedSubjectCount === 0 || this.props.OverallProgress.ExpectedSessionCount === 0) {
            return (
                <div className="row">
                    <div className="col-sm-12">
                        <div className="alert alert-warning">
                            The study metrics have not been configured for this study, the expected values below will be incorrect
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    renderLastSessionIndicator = () => {
        if (this.props.OverallProgress.LastSession) {
            return (<span>Last Session: <time dateTime={this.props.OverallProgress.LastSession}>{Moment.parseZone(this.props.OverallProgress.LastSession).format("DD-MMM-YYYY")}</time></span>);
        } else {
            return null;
        }
    }

    render() {
        if (this.props.OverallProgress) {
            return (
                <div className="row">
                    <div className="col-sm-12">
                        <div className="panel panel-default">
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-sm-6">
                                        {this.props.OverallProgress.Study}
                                    </div>
                                    <div className="col-sm-6">
                                        {this.renderLastSessionIndicator()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.renderIncorrectConfiguration()}
                        <div className="row">
                            <div className="col-sm-6">
                                <StatWidget entity="Subjects" icon="fa-users fa-solid" progress={this.props.OverallProgress.CurrentSubjectCount} total={this.props.OverallProgress.ExpectedSubjectCount} percentageComplete={this.props.OverallProgress.SubjectPercentage} tooltip="Current enrolled subjects / Expected subjects" />
                            </div>
                            <div className="col-sm-6">
                                <StatWidget entity="Sessions" icon="fa-folder" progress={this.props.OverallProgress.CurrentSessionCount} total={this.props.OverallProgress.ExpectedSessionCount} percentageComplete={this.props.OverallProgress.SessionsPercentage} tooltip="Current sessions / Expected sessions" />
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }

    }
}
